import React from 'react';
import { withFormsy } from 'formsy-react';
import '../form/validators';

class FormsySimpleTextAreaNew extends React.Component {
  state = {
    localValue: ''
  }
  render = () => {
    const {
      type,
      name,
      isValid,
      isPristine,
      placeholder,
      autoComplete,
      className = 'simple-input-new simple-input-new__text-area',
      spellCheck = 'false',
      title
    } = this.props;

    let classes = className;
    classes += isValid || isPristine ? '' : ' simple-input--error';

    const inputProps = {
      type,
      name,
      value: this.state.localValue,
      autoComplete,
      placeholder,
      className: classes,
      onChange: this.handleChange,
      onBlur: this.handleBlur,
      onFocus: this.handleFocus,
      spellCheck,
      id: name,
      rows: 6,
      maxlength: 265,
      title
    };

    return (
      <div className="simple-input-new__wrap">
        <textarea {...inputProps} />
      </div>
    );
  };

  handleChange = e => {
    let text = e.target.value
    if ('mask' in this.props) {
      text = this.props.mask(text);
    }

    this.setState({ localValue: text })

    if ('onChange' in this.props) this.props.onChange(e);
  };

  handleBlur = e => {
    if ('onBlur' in this.props) this.props.onBlur(e);
  };

  handleFocus = e => {
    if ('onFocus' in this.props) this.props.onFocus(e);
  };

  componentDidUpdate = prevProps => {
    const { value } = this.props;
    if (prevProps.value !== value) {
      this.setState({ labelUp: true });
      if (this.state.localValue !== value) {
          this.setState({ localValue: value})
      }
    }
  };

  componentDidMount = () => {
    const { value } = this.props;
    if (value) {
      this.setState({ labelUp: true });
    }
    this.setState({ localValue: value})
  };
}

export default withFormsy(FormsySimpleTextAreaNew);



// WEBPACK FOOTER //
// ./src/components/new/FormsySimpleTextAreaNew.js